import { getStateAgencyName } from 'utils/helpers';

export const NAVIGATION_SUBITEM_HOLIDAYS = 'Holidays';
export const NAVIGATION_SUBMENU_APPLICATIONS = 'Applications';
export const NAVIGATION_SUBITEM_DEPARTMENT_HOLIDAYS_ENDPOINT = `/${getStateAgencyName()}/departments/holidays`;
